export default "__VITE_ASSET__BowVQ0RF__"